export default __webpack_public_path__ + "static/media/pantry-vegshelf.1451728a.png";